var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"helpcenter-btn--container",attrs:{"href":`https://plooral.zendesk.com/hc/${_vm.language === 'pt-BR' ? 'pt-br' : 'en-us'}`,"target":"_blank"}},[_c('v-icon',{attrs:{"color":"#fff"}},[_vm._v("mdi-help-circle-outline")]),_c('span',[_vm._v(_vm._s(_vm.$t('global:help')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }